import { useContext } from "react";
import { activeTableEntityFilter, getAppliedDateLabel } from "src/services/reports.service";
import { ReportsContext } from "../..";
import styles from "./entitiesFilterTooltip.module.scss";
import Tooltip from "src/components/tooltip";
import cx from "classnames";
import _ from "lodash";
import dateFormat from "dateformat";
import moment from "moment";
import { DATE_RANGES } from "src/constants/reports";
import { AdvocacyTables, DiscoveryTables, EngagementTables, PerformanceTables, ReportTabs } from "src/types/reports";

interface EntitiesFilterTooltipProps {
    tabName: ReportTabs;
    tableName: DiscoveryTables | EngagementTables | PerformanceTables | AdvocacyTables;
}

export const EntitiesFilterTooltip: React.FC<EntitiesFilterTooltipProps> = ({ tabName, tableName }) => {
    const reportsContext = useContext(ReportsContext);

    if (!reportsContext) {
      return <></>;
    }

    const { appliedEntityFilters, reportDate } = reportsContext;
    const filteredEntity = activeTableEntityFilter(tabName, tableName, appliedEntityFilters);

   const appliedFilterLabels = (): string[]  => {
      return _.compact([getAppliedDateLabel(reportDate), ...filteredEntity]);
  }

  return (
    <>
    { _.size(filteredEntity) > 0 && 
    <Tooltip placement="top" content={<p className={styles.container}> <span className={styles.label}>Applied Filters:</span> {appliedFilterLabels().join(" | ")}</p>}>
        <i className={cx(styles.paperfliteInfo,"paperflite-report-filter")}></i>
    </Tooltip>
    } </>
  );
};